import { render, staticRenderFns } from "./Dimention.vue?vue&type=template&id=0cfe0bbe"
import script from "./Dimention.vue?vue&type=script&lang=js"
export * from "./Dimention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports